import React from 'react';
import { proofPoints } from '../../data/home';
export function ProofStrip() {
  return <section aria-label="Why Universal Packaging" className="border-b border-edge bg-ink" data-id="element-54" data-mp="3fhuhfty3cjlv">
      <ul className="mx-auto flex max-w-[1320px] flex-col flex-wrap items-center justify-center gap-x-8 gap-y-3 px-5 py-10 text-center md:flex-row md:px-8" data-id="element-55" data-mp="3are5ke9x561m">
        {proofPoints.map((point, index) => <li key={point} className="flex items-center gap-8" data-id="element-56" data-mp="31rh9hrl794wj" data-mpi={index}>
            <span className="font-display text-xl font-semibold uppercase tracking-[0.08em] text-chalk md:text-2xl" data-id="element-57" data-mp="31ov3vxhvczgy">
              {index === 0 ? <>
                  <span className="text-flame" data-id="element-58" data-mp="2rtjpjgadhu9q">25+</span> years in packaging
                </> : point}
            </span>
            {index < proofPoints.length - 1 && <span className="hidden h-2 w-2 rotate-45 bg-flame md:block" aria-hidden="true" data-id="element-59" data-mp="q0lxvnsc17qd" />}
          </li>)}
      </ul>
    </section>;
}